const INITIAL_STATE = {
  formas: [],
  metodosRecebimentos: [],
  recebimentos: [],
  dadosFiltro: {
    filtroDataAte: '',
    filtroDataDe: '',
    nome: '',
    tipo: { value: 0, label: '' },
    origem: { value: 0, label: '' },
    clear: false
  }
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'RECEBIMENTOS_FETCH':
      return { ...state, formas: action.payload }
    case 'METODO_RECEBIMENTO_FETCH':
      return { ...state, metodosRecebimentos: action.payload }
    case 'RESERVA_RECEBIMENTO_ADD':
      const novoRecebimento = {
        valor: "",
        formaRecebimento: { label: 'Selecione a forma de recebimento!', value: '' },
        parcela: { label: '1X', value: 1 }
        //   local: "",
      }
      return { ...state, recebimentos: state.recebimentos.concat(novoRecebimento) }
    case 'RESERVA_RECEBIMENTOS_CHANGE_VALOR':
      var copyPagamentos = [...state.recebimentos]
      var newValor = { ...copyPagamentos[action.index] }
      newValor.valor = action.payload
      copyPagamentos[action.index] = newValor
      return { ...state, recebimentos: copyPagamentos }
    //   case 'RESERVA_PAGAMENTO_CHANGE_LOCAL':
    //     var copyPagamentos = [...state.pagamentos]
    //     var newlocal = { ...copyPagamentos[action.index] }
    //     newlocal.local = action.payload
    //     copyPagamentos[action.index] = newlocal
    //     return { ...state, pagamentos: copyPagamentos }
    case 'RESERVA_RECEBIMENTOS_CHANGE_FORMA_PAGAMENTO':
      var copyPagamentos = [...state.recebimentos]
      var newformaPagamento = { ...copyPagamentos[action.index] }
      newformaPagamento.formaRecebimento = action.payload
      copyPagamentos[action.index] = newformaPagamento

      return { ...state, recebimentos: copyPagamentos }
    //   case 'RESERVA_PAGAMENTO_CHANGE_PARCELA':
    //     var copyPagamentos = [...state.pagamentos]
    //     var newParcela = { ...copyPagamentos[action.index] }
    //     newParcela.parcela = action.payload
    //     copyPagamentos[action.index] = newParcela
    //     return { ...state, pagamentos: copyPagamentos }
    //   case 'PAGAMENTO_FORMA_LIMPAR_ARRAY_PAGAMENTOS':
    //     // Você pode adicionar um novo item ao array aqui
    //     return { ...state, pagamentos: action.payload }
    //   case 'EDITAR_PAGAMENTO':
    //     const pagamentosDoBackEnd = action.payload;

    //     var novosPagamentos = pagamentosDoBackEnd.map((pagamento) => {
    //       return {
    //         valor: pagamento.pag_valor,
    //         formaPagamento: { label: pagamento.forma.pag_nome, value: pagamento.forma.pag_id },

    //         parcela: pagamento.parcela !== null ? { value: pagamento?.parcela?.par_id, label: pagamento?.parcela?.par_nome } : { label: 'Selecione o parcelamento!', value: '' },
    //         local: pagamento.pag_local,
    //       };
    //     });
    //     return { ...state, pagamentos: novosPagamentos };
    case 'RESERVA_REMOVER_LINHA_FORMA_RECEBIMENTO':
      var novosRecebimentos = state.recebimentos.filter((recebimento, index) => index !== action.index)
      console.log(novosRecebimentos)

      return { ...state, recebimentos: novosRecebimentos }
    case 'RECEBIMENTOS_SET_FILTRO': {
      const dadosFiltroCopy = { ...state.dadosFiltro }
      dadosFiltroCopy[action.campo] = action.valor
      return { ...state, dadosFiltro: dadosFiltroCopy }
    }
    case 'RECEBIMENTOS_SET_FILTRO_CLEAR': {
      const dadosFiltroCopy = {
        filtroDataAte: '',
        filtroDataDe: '',
        nome: '',
        tipo: { value: 0, label: '' },
        origem: { value: 0, label: '' },
        status: { value: '', label: '' },
        clear: false
      }
      return { ...state, dadosFiltro: dadosFiltroCopy }
    }
    default:
      return state
  }
}